import { createEventHook, type EventHookOn } from '@vueuse/core';

const membershipSwitchHook = createEventHook<void>();

// The hook is module-scoped, so on the server it is shared by every request for
// the lifetime of the process. Component scopes are never disposed during SSR,
// so a server-side `on()` would permanently retain one listener (and its
// captured closure) per request. Membership switches only happen on the client,
// so server-side registration is a no-op.
const onMembershipSwitch: EventHookOn<void> = (fn) => {
    if (import.meta.client) {
        return membershipSwitchHook.on(fn);
    }

    return { off: () => {} };
};

export function useMembershipSwitch() {
    return {
        emitMembershipSwitch: membershipSwitchHook.trigger,
        onMembershipSwitch
    };
}
